import { useCallback, useEffect, useRef, useState } from 'react';

// Session 24: the one save confirmation used by every save button in client
// settings and the onboarding (Add client) form. Shows "Saved" after a
// successful save (it fades after a few seconds) or "Couldn't save: {reason}"
// when the save failed (it stays until the next save).
//
//   const save = useSaveStatus();
//   async function onSave() {
//     save.start();
//     const { error } = await supabase.rpc(...);
//     if (error) return save.fail(error.message);
//     save.ok();
//   }
//   <button ...>Save</button> <SaveStatus status={save.status} />

export function useSaveStatus(okMs = 4000) {
  const [status, setStatus] = useState(null);   // null | 'saving' | 'ok' | { error }
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const start = useCallback(() => { clearTimeout(timer.current); setStatus('saving'); }, []);
  const ok = useCallback(() => {
    clearTimeout(timer.current);
    setStatus('ok');
    timer.current = setTimeout(() => setStatus(null), okMs);
    return true;
  }, [okMs]);
  const fail = useCallback((reason) => {
    clearTimeout(timer.current);
    setStatus({ error: String(reason || 'unknown error') });
    return false;
  }, []);
  const clear = useCallback(() => { clearTimeout(timer.current); setStatus(null); }, []);
  return { status, start, ok, fail, clear };
}

export function SaveStatus({ status }) {
  if (status === 'ok') return <span className="save-status save-ok" role="status">Saved</span>;
  if (status && status.error) return <span className="save-status save-err" role="alert">Couldn't save: {status.error}</span>;
  return null;
}
